import styled from 'styled-components';
import { useRef } from 'react';

const DropFiles = ({handleChange, label}) => {

  const fileInput = useRef(null);

  // Drop Handler using FileSystemHandles if available
  async function dropHandler(ev) {
    console.log("File(s) dropped");
    ev.preventDefault();
    ev.target.style.removeProperty('background-color');

    let handles = [];
    if (ev.dataTransfer.items) {
      // Process all items in sequence
      const promises = [...ev.dataTransfer.items].map(async (item) => {
        if (item.kind === "file" && item.type === "video/mp4") {
          if (item.getAsFileSystemHandle) {
            try {
              const handle = await item.getAsFileSystemHandle();
              console.log(`File handle obtained: ${handle.name}`);
              return handle;
            } catch (err) {
              console.error('Error getting file system handle:', err);
              // Fallback to regular File API
              const file = item.getAsFile();
              if (file) {
                console.log(`Fallback for ${file.name}`);
                return {
                  name: file.name,
                  getFile: async () => file
                };
              }
            }
          } else {
            // Fallback: use file object wrapped in an object with a getFile method
            const file = item.getAsFile();
            if (file) {
              console.log(`Regular file: ${file.name}`);
              return {
                name: file.name,
                getFile: async () => file
              };
            }
          }
        }
        return null;
      });
      
      // Wait for all promises and filter out nulls
      const results = await Promise.all(promises);
      handles = results.filter(Boolean);
    } else {
      // Fallback if dataTransfer.items not available
      const files = ev.dataTransfer.files;
      for (const file of files) {
        // Wrap file object to simulate a file system handle
        handles.push({
          name: file.name,
          getFile: async () => file
        });
      }
    }

    console.log(`Total handles collected: ${handles.length}`);
    handleChange(handles);
    removeDragData(ev);
  }

  //DragEnter Handler to set background color
  function dragEnterHandler(ev) {
    ev.preventDefault();
    ev.target.style.backgroundColor = "#ddd";
  }
    
  //Dragover Handler to prevent default behavior
  function dragOverHandler(ev) {
    ev.preventDefault();
  }

  //DragLeave Handler to reset background color
  function dragLeaveHandler(ev) {
    ev.preventDefault();
    ev.target.style.removeProperty('background-color');
  }

  //Remove drag data
  function removeDragData(ev) {
    console.log("Removing drag data");
  
    if (ev.dataTransfer.items) {
      ev.dataTransfer.items.clear();
    } else {
      ev.dataTransfer.clearData();
    }
  }

  // Use showOpenFilePicker if available
  async function handleClick() {
    if (window.showOpenFilePicker) {
      try {
        const handles = await window.showOpenFilePicker({
          types: [{
            description: 'MP4 Videos',
            accept: {'video/mp4': ['.mp4']}
          }],
          multiple: true
        });
        handleChange(handles);
      } catch (err) {
        console.error('File picker canceled or error:', err);
      }
    } else {
      fileInput.current.onchange = _ => {
        const files = Array.from(fileInput.current.files).map(file => ({
          name: file.name,
          getFile: async () => file
        }));
        handleChange(files);
      };
      fileInput.current.click();
    }
  }

  return ( 
    <Background>
      <input type="file" multiple accept={'video/mp4'} ref={fileInput} style={{display: 'none'}}/>
      <DropZone 
          id="drop_zone" 
          onDrop = {dropHandler}
          onDragEnter = {dragEnterHandler}
          onDragOver={dragOverHandler}
          onDragLeave={dragLeaveHandler}
          onClick={handleClick}>
          <div
            className="text-center"
            style={{opacity: 0.4, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none', height: '100%', width: '100%'}}
          >
            <img src="/images/icons/hard-drive.svg" alt="upload to cloud" />
            <img src="/images/icons/arrow-narrow-right.svg" alt="upload to cloud" />
            <img src="/images/icons/cloud-blank-01.svg" alt="upload to cloud" />
          </div>
      </DropZone>
    </Background>
  );
}

const Background = styled.div`
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;    
`;

const DropZone = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px dashed #ccc;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #bbb;
    font-size: 1.2rem;
    cursor: pointer;
`;

export default DropFiles;